var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 34,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M21.322 17.072a5.476 5.476 0 01-5.477 5.476 5.477 5.477 0 01-5.48-5.476c0-.39.044-.772.123-1.14H4.066v8.714a4.02 4.02 0 004.022 4.022H23.24c2.22 0 4.023-1.8 4.023-4.022v-8.713H21.2c.077.367.122.748.122 1.14m1.918-11.6H8.088a4.024 4.024 0 00-4.022 4.024v4.29h7.42c1-1.323 2.57-2.194 4.36-2.194 1.786 0 3.358.87 4.358 2.195h7.06v-4.29a4.025 4.025 0 00-4.024-4.025m1.51 4.728c0 .58-.465 1.04-1.04 1.04h-1.347c-.575 0-1.04-.46-1.04-1.04V8.86c0-.575.465-1.04 1.04-1.04h1.346c.57 0 1.04.465 1.04 1.04v1.34"
  })));
}
export default SvgInstagramIcon;